<template>
  <div class="space-y-6">
    <!-- Header -->
    <div class="text-center space-y-2">
      <h2 class="text-2xl font-bold text-foreground">
        {{ $t('vet.signup.problem.title') }}
      </h2>
      <p class="text-muted-foreground">
        {{ $t('vet.signup.problem.description') }}
      </p>
    </div>

    <!-- Problem Description -->
    <div class="space-y-2">
      <UiTextarea
        v-model="problemDescription"
        :placeholder="$ts('vet.signup.problem.placeholder')"
        :rows="6"
        class="resize-none"
        @input="handleInput"
      />
      <p class="text-xs text-muted-foreground">
        {{ $t('vet.signup.problem.hint') }}
      </p>
    </div>

    <!-- Navigation -->
    <div class="flex justify-between pt-4">
      <UiButton variant="outline" @click="$emit('back')">
        <Icon name="tabler:arrow-left" size="16" />
        {{ $t('vet.signup.navigation.back') }}
      </UiButton>
      <UiButton
        class="bg-bubba-blue hover:bg-bubba-blue/90"
        @click="handleNext"
      >
        {{ $t('vet.signup.navigation.next') }}
        <Icon name="tabler:arrow-right" size="16" />
      </UiButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
// TODO : Add voice input option (voice-to-text) for problem description
import type { SignupFormData } from '#composables/vet/useVetSignupWizard';

const props = defineProps<{
  formData: SignupFormData;
}>();

const emit = defineEmits<{
  update: [data: Partial<SignupFormData>];
  next: [];
  back: [];
}>();

const problemDescription = ref(props.formData.problemDescription || '');

function handleInput() {
  emit('update', { problemDescription: problemDescription.value });
}

function handleNext() {
  emit('next');
}
</script>
